import * as React from 'react';
import {clsx} from 'clsx';

import {useTranslation} from 'common/i18n/hooks';
import {isFirstTimeEventFilter} from 'common/widgets/property-filter-menu/models/utils';
import {SelectTheme} from 'common/components/select/constants';
import {PropertyFilter} from 'common/widgets/property-filter-menu/models/property-filter';
import {SectionItem} from 'common/components/items-menu/types';
import {ButtonSize} from 'common/components/button/constants';
import {SelectReact} from 'common/components/select';

import {FiltersOperator, FiltersOperatorDisplayLabels} from '../types';

export function RowFiltersPrefix(props: {
  filtersOperator: FiltersOperator;
  filter: PropertyFilter;
  filterIndex: number;
  handleChange: (item: SectionItem) => void;
  forceDisabled?: boolean;
  isReadOnlyMode: boolean;
  forBehaviors?: boolean;
  filtersOperators?: FiltersOperator[];
  forNewUI?: boolean;
}) {
  const {t, print} = useTranslation();

  let canSwitch = false;
  let label = ``;
  let operators: FiltersOperator[] = [];

  const forExtendedLogicalOperators =
    props.filtersOperators &&
    (props.filtersOperators.includes(FiltersOperator.AndAny) || props.filtersOperators.includes(FiltersOperator.OrAll));
  const isExtendedLogicalOperator =
    props.filtersOperator === FiltersOperator.AndAny || props.filtersOperator === FiltersOperator.OrAll;

  // behavior filter as first filter
  if (props.filter && isFirstTimeEventFilter(props.filter)) {
    label = `for the`;
    if (props.forNewUI) {
      return null;
    }
    // first non-behavior filter
  } else if (props.filterIndex === 0 && !props.forNewUI) {
    label = props.forBehaviors ? t(`filters.user-operator.who`) : t(`filters.user-operator.where`);
  } else {
    label = print(FiltersOperatorDisplayLabels[props.filtersOperator]);
    canSwitch = true;
    operators = props.filtersOperators || [FiltersOperator.And, FiltersOperator.Or];
  }

  // for sidebar QB we display `And all, Or any`
  let labelMappings = FiltersOperatorDisplayLabels;
  if (props.forNewUI && !forExtendedLogicalOperators) {
    labelMappings = {
      [FiltersOperator.And]: t(`filters.group-operator.and-all`),
      [FiltersOperator.Or]: t(`filters.group-operator.or-any`),
    };
    label = print(labelMappings[props.filtersOperator]);
  }

  // and/or switch
  return (
    <div
      className={clsx(`entry-selector-prefix`, {
        'behavior-mode': props.forBehaviors,
        'for-extended-operators': forExtendedLogicalOperators,
      })}
    >
      {!(isExtendedLogicalOperator && props.filterIndex > 1) && (
        <SelectReact
          className={clsx(`filters-operator-select`, {
            'is-disabled': props.forceDisabled || !canSwitch,
          })}
          readonly={props.isReadOnlyMode || props.forceDisabled || !canSwitch}
          elref='filtersOperatorSelect'
          theme={props.forNewUI ? SelectTheme.Secondary : SelectTheme.Tertiary}
          menuWidth={90}
          alwaysShowCaret={props.forNewUI}
          size={props.forNewUI ? ButtonSize.Small : ButtonSize.Medium}
          sections={[
            {
              items: operators.map(
                (operator) =>
                  ({
                    isSelected: props.filtersOperator && operator === props.filtersOperator.toString(),
                    value: operator,
                    label: labelMappings[operator],
                  }) as SectionItem,
              ),
            },
          ]}
          {...(label ? {selectedOption: label} : {})}
          onChange={(ev: any) => props.handleChange(ev.detail.item as SectionItem)}
        />
      )}
    </div>
  );
}
